export const locale = {
  lang: 'pt',
  data: {
    'AVANCES': {
      'GOSURVEY':'Vá para a pesquisa',
      'GOPORTAL':'Vá para a porta de contagem',
      'REGRESAR':'Para retornar',
      'DESCARGAR':'Baixar excel',
      'PRIMEROS':'Primeiro 1000',
      'SINCRONIZAR':'Sincronizar com portal de contagem',
      'PRODUCTO':'Product',
      'FEC-LAN': 'Data de lançamento',
      'FEC-CIE': 'Data de encerramento',
      'NOFEC-LAN': "Você ainda não agendou uma data de lançamento",
      'FEC-CIE-PROR': 'Data de encerramento prorrogada',
      'CER': 'Fechar pesquisa',
      'ABR': 'Pesquisa aberta',
      'PROR':'PROROGATIVE',
      'SURVEY':'Pesquisa: ',
      'FILE':'Cultura Go Cloud Drive: ',
      'WARNING-FECHA-GUARDAR':'Tem a certeza de acrescentar extensões datadas',
      'SUCCESS-PRORROGA': 'A data de encerramento foi alterada para',
      'WARNING-CIERRE-ENCUESTA':'Tem a certeza de alterar o estado do inquérito',
      'SUCCESS-CIERRE': 'O inquérito foi alterado correctamente',
      'PORCENTAJE':'Visualização das respostas: ',
      'DES':'Clique para mostrar    ',
      'WARNING-BTN':'Atualmente, não realizei essa ação, pois sua pesquisa não foi lançada',
      'PROCESARRESU': 'Resultados do processo',
      'ETIQUETAS':{
        'ETIQUETAS': 'itens por página',
        'OF': 'de',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>Para confirmar a remoção das respostas do usuário',
          'MESSAGE2':', digite o nome do usuário na caixa de texto</span>',
          'MESSAGE3':'<span>Para confirmar a remoção das respostas do usuário, digite o nome do usuário na caixa de texto ',
          'SALIR': 'Saída',
          'VALIDAR': 'Confirmar usuário',
          'ERRORNOMBREEMPRESA': 'O nome do usuário inserido não corresponde ao nome do usuário que você deseja excluir',
          'MENSAJE': '¿Tem certeza?\n\nVocê está prestes a deletar as respostas dos usuários',
          'CANCELAR': 'Cancelar',
          'CONFIRMAR': 'Sim, deleta',
          'SUCCES': 'Respostas deletars',
          'CERRAR': 'Perto'
        },
        'MESSAGE':'¿Tem certeza que deseja deletar as respostas do usuário',
        'RESP_SI':'Sim',
        'RESP_NO':'Não',
        'ACEPTAR':' Aceitar',
        'CANCELAR':'Cancelar',
        'OK':'Está bem',
        'SUCCESS-DELETE':'Respostas excluídas com sucesso',
        'ERROR-DELETE':'Aconteceu algo de errado',
      },
      'PROCESAR': {
        'OK': 'O processo começou com sucesso',
        'NOTOK': 'O processo não pôde ser iniciado, primeiro você precisa definir os resultados desejados'
      },
      'INS':{
        'INS1':' do ',
        'INS2':' colaboradores '
      },
      'INICIO':{
        'TITULO':'Status da pesquisa do usuário',
        'INSTRUCCIONES':'No lado esquerdo, há um bar com os produtos comprados pela empresa. Clicando em um deles mostra os clientes por ano, selecione um para poder mostrar a lista de usuários que estão realizando a pesquisa desse produto.',
      },
      'ENCUESTA':{
        'TTITULO': 'Visualização do pesquisas por usuário',
        'PRODUCTS':'Produtos adquiridos',
        'LABEL01':'Nome',
        'LABEL02':'Correio eletrônico',
        'LABEL03':'Chave',
        'LABEL04':'Status',
        'LABEL05':'Convite',
        'LABEL06':'Lembrete',
        'LABEL07':'Excluir',
        'LABEL08':'Iniciar',
        'LABEL09':'Fim',
        'LABEL10':'Ações do usuário',
        'LABEL11':'Ações de pesquisa',
        'LABEL12':'Chave de acesso',
        'DESCARGAR':'Fazendo o download, aguarde ...',
        'BUSCAR':'Pesquisa',
        'TITULOEXCEL':'Status da pesquisa',
        'CARGANDO':'Carregando',
        'ACTIVA':'Pesquisa não habilitada',

        //, aguarde .... o número total de usuários que você tem é'
        'PLACE':'Escreva o nome do colaborador que você deseja procurar',
        'ACTIONS':'ações ocultas',
        'NOUSER':'Pesquisa não encontrada',
        'NA':'Não disponível',
        'ERROR':'Este produto ainda não tem uma pesquisa',
        'SUCCESS1':'Convite enviado',
        'SUCCESS2':'Lembrete enviado',
        'ERROR1':'Aconteceu algo de errado',
      },
      'TITULOS':{
        'NAME':'Nome do colaborador',
        'ESTADOS':'Status da pesquisa',
        'FECHA1':'Data de início',
        'FECHA2':'Data em que a pesquisa terminou',
        'ESTADOS_ENC':{
          'TITULO':'Selecione uma opção',
          'TODO':'Mostre tudo',
          'ESTADO1':'Ainda não iniciou a pesquisa',
          'ESTADO2':'Você está logado',
          'ESTADO3':'Pesquisa em andamento',
          'ESTADO4':'A pesquisa terminou',
          'ESTADO5': 'Não Aceite',
          'ESTADO6':'Aceito o inquérito',
        }
      },
      'COLUMNAS':{
        'email':'Correio eletrônico',
        'end_date':'Data final',
        'id_status':'Condição',
        'name':'Nome',
        'start_date':'Fecha de inicio'
      },
      'ACCIONES_EMAIL':{
        'ACCIONES':'Ações de Pesquisa',
        'INFO':'As próximas etapas mostram as ações disponíveis para o usuário',
        'ACC1':'Enviar convite',
        'ACC2':'Mande um lembreter',
        'ACC3':'Excluir resposta da pesquisa',
      },
      'NEWCOLAB': {
        'TITULO': 'Adicionar novo participante à pesquisa',
        'INST_1': 'Complete cada um dos conjuntos de dados necessários para adicionar um novo participante',
        'TITULO_MOD': 'Modificar dados de colaboradores',
        'INST_1_MOD': 'Você pode fazer modificações em cada um dos conjuntos de dados do colaborador selecionado',
        'INST_2': 'Os campos marcados com (*) são obrigatórios',
        'WARNING1':'NOTA: A CHAVE DESTE COLABORADOR ',
        'WARNING2':' NÃO PODE SER MODIFICADO',
        'DATASET_1': 'Conjunto de dados 1',
        'DATASET_2': 'Conjunto de dados 2',
        'DATASET_3': 'Conjunto de dados 3',
        'DATASET_4': 'Conjunto de Dados 4',
        'DATASET_5': 'Conjunto de Dados 5',
        'DATASET_6': 'Conjunto de Dados 6',
        'DATASET_7': 'Conjunto de dados 7',
        'REQUIRED': 'Este campo é obrigatório',
        'NEXT': 'Próximo',
        'BACK': 'Anterior',
        'SAVE': 'Salve ',
        'ERR_OWNKEY': 'O número do funcionário inserido já está armazenado no banco de dados, tente um diferente',
        'ERR_BOSSKEY': 'O número do chefe inserido não está armazenado no banco de dados, tente um diferente',
        'ERR_VAL_1': 'Os dados inseridos no campo:',
        'ERR_VAL_2': 'contém caracteres ilegais ou não está no formato correto',
        'GUARDANDO': 'As informações do participante estão sendo armazenadas, por favor, aguarde',
        'GUARDANDO_GOFLOW': 'A informação está a ser armazenada, por favor aguarde.',
        'SAVE_OK': 'As informações do novo participante foram armazenadas corretamente',
        'MOD_OK': 'As informações do participante foram modificadas com sucesso',
        'FORMULARIO': 'Você ainda não preencheu o formulário de registro, verifique se preencheu todos os campos obrigatórios e tente novamente',
        'ACCIONES': 'Ações',
        'VERACT': 'Ações especiais',
        'LOADACT': 'Carregando ações disponíveis',
        'NOACT': 'Nenhuma ação adicional pode ser realizada para este contribuidor',
        'AVAACT': 'As seguintes ações podem ser realizadas para colaborador',
        'ACCIONLIST': {
          'modificar': 'Modifica as informações do colaborador selecionado',
          'borrar': 'Excluir o colaborador selecionado'
        },
        'DELCOLAB': 'Você confirma a remoção do colaborador selecionado deste produto? Nota: Esta ação não pode ser revertida',
        'DEL_OK': 'Este colaborador foi removido com sucesso do produto',
        'ERR_EMAIL': 'O endereço de e-mail inserido já está armazenado no banco de dados, tente outro',
        'ERR_SAMEKEY': 'A chave do chefe inserida e a chave do colaborador são as mesmas, isso não é permitido, tente uma diferente',
        'RESET_COLAB_SURVE': 'Confirma para reiniciar o acesso ao inquérito? ',
        'ACTU_OK': 'Foi actualizado correctamente',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': 'Perspectiva',
        'statementID': 'Reactive ID',
        'dimensionL1': 'Dimension L1',
        'dimensionL2': 'Dimension L2',
        'survey_Score_OverallTI': 'Inquérito de Pontuação GlobalTI',
        'company_Country': 'Pais empresa',
        'cgo_Product_Name': 'Nome do produto cgo',
        'company_Name': 'Nome da empresa',
        'ranking_Year': 'Ano de classificação',
        'survey_Respondents': 'Respondentes',
        'survey_Score_Camaraderie': 'Pesquisa de Pontuação de Camaradagem',
        'survey_Score_Credibility': 'Credibility Score Survey',
        'survey_Score_Imparciality': 'Levantamento da Pontuação da Imparcialidade',
        'survey_Score_Pride': 'Inquérito de Pontuação de Orgulho',
        'survey_Score_Respect': 'Inquérito de Pontuação de Respeito',
        'survey_Score_Gestalt': 'Pesquisa de Pontuação Gestalt',
        'pdf_DateCreation': 'Data de criação do certificado',
        'WARNI_TI_DA': 'O valor introduzido não corresponde ao formato permitido (100,00)',
        'WARNI_TI_DA_GRAL': 'Os dados introduzidos não se encontram no formato especificado',
      },
      'FORMULARIO':{
        'fullName': 'Nome do colaborador',
        'ownKey': 'Número / senha do colaborador',
        'age': 'Ano de nascimento',
        'surveyKey': 'Senha para entrar na pesquisa',
        'email': 'Correio eletrônico',
        'bossName': 'Nome do chefe direto',
        'bossKey': 'Número / código do chefe direto',
        'country': 'País',
        'location': 'Localização',
        'geo_1': 'Nível geográfico 1',
        'geo_2': 'Nível geográfico 2',
        'geo_3': 'Nível geográfico 3',
        'geo_4': 'Nível geográfico 4',
        'geo_5': 'Nível geográfico 5',
        'geo_6': 'Nível geográfico 6',
        'geo_7': 'Nível geográfico 7',
        'geo_8': 'Nível geográfico 8',
        'geo_9': 'Nível geográfico 9',
        'geo_10': 'Nível geográfico 10',
        'geo_19': 'Nível geográfico 19',
        'structure_1': 'Nível estrutural 1',
        'structure_2': 'Nível estrutural 2',
        'structure_3': 'Nível estrutural 3',
        'structure_4': 'Nível estrutural 4',
        'structure_5': 'Nível estrutural 5',
        'structure_6': 'Nível estrutural 6',
        'structure_7': 'Nível estrutural 7',
        'structure_8': 'Nível estrutural 8',
        'structure_9': 'Nível estrutural 9',
        'structure_10': 'Nível estrutural 10',
        'area': 'Área',
        'bUnit': 'Unidade de negócio',
        'enterDate': 'data de admissão',
        'antiquity': 'Antiguidade',
        'antiquityUS': 'Antiguidade US',
        'generation': 'Geração',
        'generationUS': 'Geração dos EUA',
        'ageUS': 'Era',
        'charge': 'Cargo ou função na empresa',
        'homologado': 'Cargo ou função oficial',
        'homologadoUS': 'Cargo ou função aprovada nos EUA',
        'gender': 'Gênero',
        'genderType': 'Tipo de gênero',
        'typeofwork': 'Esquema de compensação',
        'workCondition': 'Condição de trabalho',
        'academico': 'Grau acadêmico',
        'contratacion': 'Tipo de contrato',
        'situacionUS': 'Status de emprego nos EUA',
        'personal': 'Tipo de pessoal',
        'jornada': 'Tipo de jornada de trabalho',
        'rotacion': 'Mudança de rotação',
        'phone': 'Telefone',
        'extension': 'Extensão',
        'cellphone': 'Número de celular',
        'native': 'Língua materna',
        'answer': 'Responda',
        'other_1': 'Outros 1',
        'other_2': 'Outros 2',
        'other_3': 'Outros 3',
        'other_4': 'Outros 4',
        'other_5': 'Outros 5',
        'other_6': 'Outros 6',
        'other_7': 'Outros 7',
        'other_8': 'Outros 8',
        'other_9': 'Outros 9',
        'other_10': 'Outros 10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO':'Sincronizando com o portal de contagem, por favor aguarde...',
        'SUCCESS':'Sincronização concluída corretamente'
      }
    },
  }
};
